import { cn } from '../../utils/classNames';
import {
  dateInputClasses,
  dateInputEmptyClasses,
  datePlaceholderClasses,
  fieldErrorClasses,
  fieldLabelClasses
} from './easyModeClasses';

// A native date input ignores placeholder and renders yyyy-mm-dd instead, which the mock does not
// show. Hiding that text while the field is empty and unfocused is the only way to reach the mock
// without giving up the native picker, so the shared DatePicker stays untouched for Classic Intake.
const EasyModeDateField = ({ label, name, value, onChange, onBlur, error, max }) => (
  <>
    {label && <label className={fieldLabelClasses}>{label}</label>}
    <div className="relative w-full">
      <input
        type="date"
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        max={max}
        className={cn(
          dateInputClasses,
          'peer',
          !value && dateInputEmptyClasses,
          !value && 'focus:text-content'
        )}
      />
      {!value && <span className={cn(datePlaceholderClasses, 'peer-focus:hidden')}>Select Date</span>}
      {error && <span className={fieldErrorClasses}>{error}</span>}
    </div>
  </>
);

export default EasyModeDateField;
